import { render, staticRenderFns } from "./AITechSkills.vue?vue&type=template&id=883cea2a&scoped=true"
import script from "./AITechSkills.vue?vue&type=script&lang=js"
export * from "./AITechSkills.vue?vue&type=script&lang=js"
import style0 from "./AITechSkills.vue?vue&type=style&index=0&id=883cea2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883cea2a",
  null
  
)

export default component.exports